import React from "react";
import styled from "styled-components";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

//
import ReviewCard from "../../../components/review-card/ReviewCard";
import REVIEWERLIST from "../../../assets/data/review-list";

export default function MainReview({ bg = "--bg" }) {
  const { t } = useTranslation();

  return (
    <StyledMainReview $bg={bg}>
      <div className="container">
        <div className="main-review__wrap">
          <h1 dangerouslySetInnerHTML={{ __html: t("mainReviewTitle") }} />
          <p dangerouslySetInnerHTML={{ __html: t("mainReviewText") }} />
          <ul>
            {REVIEWERLIST.slice(0, 3).map((i) => (
              <li key={i.id}>
                <ReviewCard
                  name={i.name}
                  title={i.title}
                  text={i.text}
                  img={i.img}
                  reviewPlace={i.reviewPlace}
                />
              </li>
            ))}
          </ul>
          <div className="main-review__link">
            <Link to="/about/review" className="hover-underline">
              {t("mainReviewLinkText")} {">>"}
            </Link>
          </div>
        </div>
      </div>
    </StyledMainReview>
  );
}

const StyledMainReview = styled.section`
  background-color: ${(props) => props.$bg && `var(${props.$bg})`};
  padding: 140px 0;

  .main-review {
    &__wrap {
      & > h1 {
        text-align: center;
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: var(--space-title-subtitle);

        span {
          color: var(--light-blue);
        }
      }

      & > p {
        text-align: center;
        color: var(--text);
        font-size: var(--fs-subtitle);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-subtitle);
        margin: 0 auto;
      }

      & > ul {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: 40px;
        margin: 48px 0;

        li {
        }
      }
    }

    &__link {
      display: flex;
      justify-content: center;

      a {
        color: var(--dark-blue);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 147.059% */

        &::after {
          background-color: var(--dark-blue);
        }
      }
    }
  }
`;
